import { dropUndefinedKeys } from '@sentry/utils';
import { getClient, getCurrentScope } from './currentScopes.js';

/**
 * Send user feedback to Sentry.
 */
function captureFeedback(
  feedbackParams,
  hint = {},
) {
  const { message, name, email, url, source, associatedEventId } = feedbackParams;

  const client = getClient();

  const feedbackEvent = {
    contexts: {
      feedback: dropUndefinedKeys({
        contact_email: email,
        name,
        message,
        url,
        source,
        associated_event_id: associatedEventId,
      }),
    },
    type: 'feedback',
    level: 'info',
  };

  if (client) {
    client.emit('beforeSendFeedback', feedbackEvent, hint);
  }

  const eventId = getCurrentScope().captureEvent(feedbackEvent, hint);

  return eventId;
}

export { captureFeedback };
//# sourceMappingURL=feedback.js.map
